<template>
  <article class="stay" v-show="show">
    <div class="bj">
      <div class="title">{{ title }}<button @click="goTop()">免费体验</button></div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
  data() {
    return {
      title: '房地产行业电子签名解决方案',
    }
  },
  methods: {
    goTop() {
      if (document.body.scrollIntoView) {
        document.body.scrollIntoView({ behavior: 'smooth' })
      } else {
        document.body.scrollTop = document.documentElement.scrollTop = 0
      }
    },
  },
}
</script>

<style lang="less" scoped>
.stay {
  width: 100%;
  min-width: 1180px;
  height: 78px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: #e61717;

  .bj {
    width: 1180px;
    height: 78px;
    margin: 0 auto;
    background-image: url(../../../assets/images/real-estate/stay-bj.png);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 25px;
    text-align: center;

    button {
      margin: 18px 0 18px 92px;
      width: 135px;
      height: 42px;
      border: 1px solid #ffffff;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 22px;
      border-radius: 2px;

      &:hover {
        background: #ffffff;
        border: 1px solid #ffffff;
        color: #e61717;
      }
    }
  }
}
</style>
